<template>
    <div class="sub-tit">
        <h2>주차</h2>
    </div>
    <div class="tab-menu type02">
        <ul class="tab-menu__list">
            <li class="tab-menu__item on"><a href="/park/parkIntro.do" type="button" class="tab-menu__btn">창원파티마병원 주차등록</a></li>
        </ul>
    </div>
    <div class="parkingRes_wrap">
        <div class="join-tab">
            <ul class="join-tab__list">
                <li class="join-tab__item active">
                    <div class="tit">창원파티마병원 주차등록 완료</div>
                </li>
            </ul>
        </div>

        <div class="certification">
            <ul class="contents login-box__list">
                <li class="login-box__item">
                    <h3 class="tit check_mention" style="color: #333;">차량등록이 완료되었습니다.
                        <br>입차시간으로부터 2시간 무료 주차 가능합니다.<br>감사합니다.
                    </h3>
                    <div class="btn-wrap center">
                        <a href="https://www.fatimahosp.co.kr/" class="btn blue">
                            <span>홈페이지로 이동</span>
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
      
    },
    mounted() {
       
    },
   
    methods: {
       
    },
}
</script>